import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { openExitDialog } from 'actions/exitDialog';
import { setHeroIndex } from 'actions/hero';

interface RowsRef {
  resetIndex: () => Promise<void>;
}

export const useHomeRowsBackNavigation = (): [
  React.RefObject<RowsRef>,
  (focusOnCarousel: boolean) => Promise<void>,
] => {
  const dispatch = useDispatch();
  const rowsRef = useRef<RowsRef>();

  const onBackAction = async (focusOnCarousel: boolean) => {
    if (focusOnCarousel) {
      dispatch(openExitDialog());
    } else {
      rowsRef.current && (await rowsRef.current.resetIndex());
      dispatch(setHeroIndex(0));
    }
  };

  return [rowsRef, onBackAction];
};